export const SD_EVENTS = {
  tradeInImpression: 'tradeInImpression',
  tradeInStart: 'tradeInStart',
  tradeInVehicleIndicated: 'tradeInVehicleIndicated',
  tradeInFormInitiation: 'tradeInFormInitiation',
  tradeInFormSubmission: 'tradeInFormSubmission',
  tradeInApptSet: 'tradeInApptSet',
  tradeInComplete: 'tradeInComplete',
};

export const SHIFT_DIGITAL_ANALYTICS_EVENT = 'ShiftDigitalAnalyticsEvent';
export const SHIFT_DIGITAL_ANALYTICS_LOAD_SUCCESS_EVENT = 'ShiftDigitalAnalyticsLoadSuccessEvent';
export const SHIFT_DIGITAL_MAKES = ['STELLANTIS', 'GENESISUS', 'TOYOTA', 'LEXUS', 'GMUS'];

export function getShiftDigitalScriptUrl(shiftDigitalBaseUrl, container) {
  // Generate the URL for each make dynamically
  const containerScriptSrc = SHIFT_DIGITAL_MAKES.reduce((acc, make) => {
    acc[make] = `${shiftDigitalBaseUrl}/scripts/${make}/sd.js`;
    return acc;
  }, {});

  // Return the selected URL based on the container (make)
  return containerScriptSrc[container];
}
